import { Layout, Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { formatCurrency } from 'core/utils/currency'

import {
  type AccessorialCharge,
  getAllInRate,
  type QuoteAccessorial,
} from '../domain/QuoteAccessorial'
import {
  formatAccessorialChargeKeyAndName,
  getAccessorialNames,
} from '../presenter/quoteAccessorialPresenter'

export type QuoteSubmitSubTotalProps = {
  accessorialCharges: Array<AccessorialCharge>
  quoteAccessorials?: Array<QuoteAccessorial>
  flatRate: number
}

export function QuoteSubmitSubTotal({
  accessorialCharges,
  quoteAccessorials,
  flatRate,
}: QuoteSubmitSubTotalProps) {
  if (accessorialCharges.length > 0) {
    const accessorialNames = getAccessorialNames(quoteAccessorials)

    return (
      <Layout.Stack space="xs" align="flex-start">
        <Text>Flat Rate: {formatCurrency(flatRate, true)}</Text>
        {accessorialCharges.map(accessorialCharge => {
          const { key, name } = formatAccessorialChargeKeyAndName(
            accessorialCharge,
            accessorialNames
          )

          return (
            <Text key={key}>
              {name}:{' '}
              {accessorialCharge.rate > 0 ? formatCurrency(accessorialCharge.rate, true) : '$ -'}
            </Text>
          )
        })}
        <Text>--------------------------------------------------</Text>
        <Text variant="heading-sm-bold">
          Total: {formatCurrency(getAllInRate(accessorialCharges, flatRate), true)}
        </Text>
        <Text
          color="color-neutral-dark"
          style={{ textAlign: 'left', paddingTop: getToken('spacing-2') }}
        >
          *Breaking down the rates may increase your chances to receive final proposals.
        </Text>
      </Layout.Stack>
    )
  }
  return (
    <Text variant="heading-sm">
      Rate: <Text variant="heading-sm-bold">{formatCurrency(flatRate, true)}</Text>
    </Text>
  )
}
